var _toConsumableArray = require("/mono/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectSpread = require("/mono/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _regeneratorRuntime = require("/mono/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mono/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('web3-utils'),
    toWei = _require.toWei,
    toBN = _require.toBN;

var _require2 = require('./constants'),
    BRIDGE_MODES = _require2.BRIDGE_MODES,
    FEE_MANAGER_MODE = _require2.FEE_MANAGER_MODE,
    ERC_TYPES = _require2.ERC_TYPES;

var _require3 = require('./abis'),
    REWARDABLE_VALIDATORS_ABI = _require3.REWARDABLE_VALIDATORS_ABI;

function decodeBridgeMode(bridgeModeHash) {
  switch (bridgeModeHash) {
    case '0x92a8d7fe':
      return BRIDGE_MODES.NATIVE_TO_ERC;

    case '0xba4690f5':
      return BRIDGE_MODES.ERC_TO_ERC;

    case '0x18762d46':
      return BRIDGE_MODES.ERC_TO_NATIVE;

    default:
      throw new Error("Unrecognized bridge mode hash: '".concat(bridgeModeHash, "'"));
  }
}

var decodeFeeManagerMode = function decodeFeeManagerMode(managerModeHash) {
  switch (managerModeHash) {
    case '0xf2aed8f7':
      return FEE_MANAGER_MODE.ONE_DIRECTION;

    case '0xd7de965f':
      return FEE_MANAGER_MODE.BOTH_DIRECTIONS;

    default:
      throw new Error("Unrecognized fee manager mode hash: '".concat(managerModeHash, "'"));
  }
};

function getBridgeMode(_x) {
  return _getBridgeMode.apply(this, arguments);
}

function _getBridgeMode() {
  _getBridgeMode = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(contract) {
    var bridgeModeHash;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return contract.methods.getBridgeMode().call();

          case 3:
            bridgeModeHash = _context8.sent;
            return _context8.abrupt("return", decodeBridgeMode(bridgeModeHash));

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", BRIDGE_MODES.NATIVE_TO_ERC_V1);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));
  return _getBridgeMode.apply(this, arguments);
}

var getTokenType =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(bridgeTokenContract, bridgeAddress) {
    var resultBridgeAddress;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return bridgeTokenContract.methods.bridgeContract().call();

          case 3:
            resultBridgeAddress = _context.sent;

            if (!(resultBridgeAddress === bridgeAddress)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", ERC_TYPES.ERC677);

          case 8:
            return _context.abrupt("return", ERC_TYPES.ERC20);

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", ERC_TYPES.ERC20);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function getTokenType(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getUnit = function getUnit(bridgeMode) {
  var unitHome = null;
  var unitForeign = null;

  if (bridgeMode === BRIDGE_MODES.NATIVE_TO_ERC) {
    unitHome = 'Native coins';
    unitForeign = 'Tokens';
  } else if (bridgeMode === BRIDGE_MODES.ERC_TO_ERC) {
    unitHome = 'Tokens';
    unitForeign = 'Tokens';
  } else if (bridgeMode === BRIDGE_MODES.ERC_TO_NATIVE) {
    unitHome = 'Native coins';
    unitForeign = 'Tokens';
  } else {
    throw new Error("Unrecognized bridge mode: ".concat(bridgeMode));
  }

  return {
    unitHome: unitHome,
    unitForeign: unitForeign
  };
};

var parseValidatorEvent = function parseValidatorEvent(event) {
  if (event.event === undefined && event.raw && event.raw.topics && (event.raw.topics[0] === '0xe366c1c0452ed8eec96861e9e54141ebff23c9ec89fe27b996b45f5ec3884987' || event.raw.topics[0] === '0x8064a302796c89446a96d63470b5b036212da26bd2debe5bec73e0170a9a5e83')) {
    var rawAddress = event.raw.topics.length > 1 ? event.raw.topics[1] : event.raw.data;
    var address = '0x' + rawAddress.slice(26);
    event.event = 'ValidatorAdded';
    event.returnValues.validator = address;
  } else if (event.event === undefined && event.raw && event.raw.topics && event.raw.topics[0] === '0xe1434e25d6611e0db941968fdc97811c982ac1602e951637d206f5fdda9dd8f1') {
    var _rawAddress = event.raw.data === '0x' ? event.raw.topics[1] : event.raw.data;

    var _address = '0x' + _rawAddress.slice(26);

    event.event = 'ValidatorRemoved';
    event.returnValues.validator = _address;
  }
};

var processValidatorsEvents = function processValidatorsEvents(events) {
  var validatorList = new Set();
  events.forEach(function (event) {
    parseValidatorEvent(event);

    if (event.event === 'ValidatorAdded') {
      validatorList.add(event.returnValues.validator);
    } else if (event.event === 'ValidatorRemoved') {
      validatorList.delete(event.returnValues.validator);
    }
  });
  return Array.from(validatorList);
};

var tryCall =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(method, fallbackValue) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return method.call();

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", fallbackValue);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));

  return function tryCall(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getDeployedAtBlock =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(contract) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", tryCall(contract.methods.deployedAtBlock(), 0));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getDeployedAtBlock(_x6) {
    return _ref3.apply(this, arguments);
  };
}();

var getPastEvents =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(contract, _ref4) {
    var _ref4$event, event, _ref4$fromBlock, fromBlock, _ref4$toBlock, toBlock, _ref4$options, options, events, middle, middlePlusOne, firstHalfEvents, secondHalfEvents;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref4$event = _ref4.event, event = _ref4$event === void 0 ? 'allEvents' : _ref4$event, _ref4$fromBlock = _ref4.fromBlock, fromBlock = _ref4$fromBlock === void 0 ? toBN(0) : _ref4$fromBlock, _ref4$toBlock = _ref4.toBlock, toBlock = _ref4$toBlock === void 0 ? 'latest' : _ref4$toBlock, _ref4$options = _ref4.options, options = _ref4$options === void 0 ? {} : _ref4$options;
            _context4.prev = 1;
            _context4.next = 4;
            return contract.getPastEvents(event, _objectSpread({}, options, {
              fromBlock: fromBlock,
              toBlock: toBlock
            }));

          case 4:
            events = _context4.sent;
            _context4.next = 22;
            break;

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](1);

            if (!(_context4.t0.message.includes('query returned more than') && toBlock !== 'latest')) {
              _context4.next = 21;
              break;
            }

            middle = toBN(fromBlock).add(toBlock).divRound(toBN(2));
            middlePlusOne = middle.add(toBN(1));
            _context4.next = 14;
            return getPastEvents(contract, _objectSpread({}, options, {
              event: event,
              fromBlock: fromBlock,
              toBlock: middle
            }));

          case 14:
            firstHalfEvents = _context4.sent;
            _context4.next = 17;
            return getPastEvents(contract, _objectSpread({}, options, {
              event: event,
              fromBlock: middlePlusOne,
              toBlock: toBlock
            }));

          case 17:
            secondHalfEvents = _context4.sent;
            events = [].concat(_toConsumableArray(firstHalfEvents), _toConsumableArray(secondHalfEvents));
            _context4.next = 22;
            break;

          case 21:
            throw new Error(_context4.t0);

          case 22:
            return _context4.abrupt("return", events);

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 7]]);
  }));

  return function getPastEvents(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

var getValidatorList =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(address, eth, options) {
    var validatorsContract, validators, deployedAtBlock, fromBlock, toBlock, validatorsEvents;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            options.logger && options.logger.debug && options.logger.debug('getting validatorList');
            validatorsContract = new eth.Contract(REWARDABLE_VALIDATORS_ABI, address); // in monitor, BRIDGE_VALIDATORS_ABI was used

            _context5.next = 4;
            return tryCall(validatorsContract.methods.validatorList(), []);

          case 4:
            validators = _context5.sent;

            if (!validators.length) {
              _context5.next = 7;
              break;
            }

            return _context5.abrupt("return", validators);

          case 7:
            options.logger && options.logger.debug && options.logger.debug('getting validatorsEvents');
            _context5.next = 10;
            return tryCall(validatorsContract.methods.deployedAtBlock(), 0);

          case 10:
            deployedAtBlock = _context5.sent;
            fromBlock = options.fromBlock || Number(deployedAtBlock) || 0;
            toBlock = options.toBlock || 'latest';
            _context5.next = 15;
            return getPastEvents(new eth.Contract([], address), {
              event: 'allEvents',
              fromBlock: fromBlock,
              toBlock: toBlock,
              options: {}
            });

          case 15:
            validatorsEvents = _context5.sent;
            return _context5.abrupt("return", processValidatorsEvents(validatorsEvents));

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getValidatorList(_x9, _x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();

var gasPriceWithinLimits = function gasPriceWithinLimits(gasPrice, limits) {
  if (!limits) {
    return gasPrice;
  }

  if (gasPrice < limits.MIN) {
    return limits.MIN;
  } else if (gasPrice > limits.MAX) {
    return limits.MAX;
  } else {
    return gasPrice;
  }
};

var normalizeGasPrice = function normalizeGasPrice(oracleGasPrice, factor) {
  var limits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var gasPrice = oracleGasPrice * factor;
  gasPrice = gasPriceWithinLimits(gasPrice, limits);
  return toBN(toWei(gasPrice.toFixed(2).toString(), 'gwei'));
}; // fetchFn has to be supplied (instead of just url to oracle),
// because this utility function is shared between Browser and Node,
// we use built-in 'fetch' on browser side, and `node-fetch` package in Node.


var gasPriceFromOracle =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(fetchFn) {
    var options,
        response,
        json,
        oracleGasPrice,
        normalizedGasPrice,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
            _context6.prev = 1;
            _context6.next = 4;
            return fetchFn();

          case 4:
            response = _context6.sent;
            _context6.next = 7;
            return response.json();

          case 7:
            json = _context6.sent;
            oracleGasPrice = json[options.speedType];

            if (oracleGasPrice) {
              _context6.next = 12;
              break;
            }

            options.logger && options.logger.error && options.logger.error("Response from Oracle didn't include gas price for ".concat(options.speedType, " type."));
            return _context6.abrupt("return", null);

          case 12:
            normalizedGasPrice = normalizeGasPrice(oracleGasPrice, options.factor, options.limits);
            options.logger && options.logger.debug && options.logger.debug({
              oracleGasPrice: oracleGasPrice,
              normalizedGasPrice: normalizedGasPrice
            }, 'Gas price updated using the API');
            return _context6.abrupt("return", normalizedGasPrice);

          case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](1);
            options.logger && options.logger.error && options.logger.error("Gas Price API is not available. ".concat(_context6.t0.message));

          case 20:
            return _context6.abrupt("return", null);

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 17]]);
  }));

  return function gasPriceFromOracle(_x12) {
    return _ref7.apply(this, arguments);
  };
}();

var gasPriceFromContract =
/*#__PURE__*/
function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(bridgeContract) {
    var options,
        gasPrice,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            _context7.prev = 1;
            _context7.next = 4;
            return bridgeContract.methods.gasPrice().call();

          case 4:
            gasPrice = _context7.sent;
            options.logger && options.logger.debug && options.logger.debug({
              gasPrice: gasPrice
            }, 'Gas price updated using the contracts');
            return _context7.abrupt("return", gasPrice);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](1);
            options.logger && options.logger.error && options.logger.error("There was a problem getting the gas price from the contract. ".concat(_context7.t0.message));

          case 12:
            return _context7.abrupt("return", null);

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 9]]);
  }));

  return function gasPriceFromContract(_x13) {
    return _ref8.apply(this, arguments);
  };
}();

module.exports = {
  decodeBridgeMode: decodeBridgeMode,
  decodeFeeManagerMode: decodeFeeManagerMode,
  getBridgeMode: getBridgeMode,
  getTokenType: getTokenType,
  getUnit: getUnit,
  parseValidatorEvent: parseValidatorEvent,
  processValidatorsEvents: processValidatorsEvents,
  getValidatorList: getValidatorList,
  getPastEvents: getPastEvents,
  getDeployedAtBlock: getDeployedAtBlock,
  normalizeGasPrice: normalizeGasPrice,
  gasPriceFromOracle: gasPriceFromOracle,
  gasPriceFromContract: gasPriceFromContract,
  gasPriceWithinLimits: gasPriceWithinLimits
};